// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackPageViewParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackPageView";
import { useSelector } from "react-redux";

const useTrackPageView = (parameters: TrackPageViewParameters = {}, options?: Toolkit.GoogleAnalytics.Options) => {
    /* Store Custom Code - Start */
    const sessionProperties = useSelector((state: ApplicationState) => state.context.session.properties);
    /* Store Custom Code - End */

    const hookParameters: TrackPageViewParameters = {
        client_id: ga.use.clientId(options),
        language: ga.use.language(options),
        page_type: ga.use.pageType(options),
        settingsCollection: useSelector((state: ApplicationState) => getSettingsCollection(state)),
        websiteName: useSelector((state: ApplicationState) => state.context.website.name),
        /* Store Custom Code - Start */
        attribute_1: sessionProperties["greif_CustomerSize"] || "",
        attribute_2: sessionProperties["greif_CustomerUseeProcurementSystem"] || "",
        attribute_3: sessionProperties["greif_CurrentOrderProcessingMethod"] || "",
        attribute_4: sessionProperties["userCompany"] || "",
        attribute_5: sessionProperties["greif_TargetCustomer"] || "",
        /* Store Custom Code - End */
        ...parameters,
    };

    const hookOptions: Toolkit.GoogleAnalytics.Options = {
        ...options,
    };

    return (parameters: Partial<TrackPageViewParameters> = {}, options?: Toolkit.GoogleAnalytics.Options) => {
        return ga.track.pageView({ ...hookParameters, ...parameters }, { ...hookOptions, ...options });
    };
};

export default useTrackPageView;
